// @flow

import ActionTypes from "../constants/ActionTypes";
import API from "../api/";

const fetchContentTagsRequest = (): any => ({
    type: ActionTypes.FETCH_CONTENT_TAGS_REQUEST,
});

const fetchContentTagsSuccess = (tags: any): any => ({
    type: ActionTypes.FETCH_CONTENT_TAGS_SUCCESS,
    tags,
});

const fetchContentTagsFail = (error: any): any => ({
    type: ActionTypes.FETCH_CONTENT_TAGS_FAIL,
    error,
});

export const fetchContentTags =
    (): any =>
    (dispatch: any): Promise<any> => {
        dispatch(fetchContentTagsRequest());
        return API.fetchContentTags()
            .then((data: any): any => {
                dispatch(fetchContentTagsSuccess(data));
                return data;
            })
            .catch((error: any): any => {
                dispatch(fetchContentTagsFail(error));
                throw error;
            });
    };
